module.exports = __webpack_public_path__ + "static/img/strona_end.9605df2b.jpg";